import { CapturumInfoTableModule } from '@capturum/ui/info-table';
import * as i0 from '@angular/core';
import { Injectable, Component, ViewEncapsulation, Input, EventEmitter, ChangeDetectionStrategy, Inject, ViewChild, Output, NgModule } from '@angular/core';
import * as i10 from '@angular/common';
import { CommonModule } from '@angular/common';
import { CapturumListRendererModule } from '@capturum/builders/list-renderer';
import * as i2 from '@capturum/builders/core';
import { responseData, CapturumBuilderType, clone, CAPTURUM_BUILDERS_BASE_URL, CapturumBuilderCoreModule } from '@capturum/builders/core';
import { of, BehaviorSubject, Subject } from 'rxjs';
import { switchMap, shareReplay, filter, take, debounceTime, takeUntil } from 'rxjs/operators';
import * as i1 from '@capturum/api';
import { ApiService } from '@capturum/api';
import * as i2$1 from '@capturum/builders/form-renderer';
import { CapturumFormRendererModule } from '@capturum/builders/form-renderer';
import * as i3 from '@ngxs/store';
import * as i4 from '@angular/router';
import * as i6 from '@capturum/ui/api';
import { CapturumSharedModule } from '@capturum/ui/api';
import * as i7 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i9 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i11 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i12 from '@capturum/ui/sidebar';
import { CapturumSidebarModule } from '@capturum/ui/sidebar';
import * as i13 from '@capturum/ui/textarea';
import { CapturumTextareaModule } from '@capturum/ui/textarea';
import { CapturumInputModule } from '@capturum/ui/input';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
const _c0 = function (a0, a1) {
  return {
    "fa-chevron-down": a0,
    "fa-chevron-up": a1
  };
};
function BuilderCardComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵlistener("click", function BuilderCardComponent_ng_container_2_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggleCollapse());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 6);
    i0.ɵɵlistener("click", function BuilderCardComponent_ng_container_2_Template_i_click_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.toggleCollapse());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0, ctx_r0.isCollapsed, !ctx_r0.isCollapsed));
  }
}
function BuilderCardComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.title, "\n");
  }
}
const _c1 = ["*"];
const _c2 = ["sidebar"];
const _c3 = function (a0, a1, a2) {
  return {
    "fa-check-circle": a0,
    "fa-exclamation-circle": a1,
    "fa-info-circle": a2
  };
};
function BuilderDetailTemplateComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", message_r6.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c3, message_r6.type === "success", message_r6.type === "warning", message_r6.type === "info"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", message_r6.message, " ");
  }
}
function BuilderDetailTemplateComponent_cap_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 6);
    i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_cap_button_11_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.setConfig());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 1, "builders.button.set-config"));
  }
}
function BuilderDetailTemplateComponent_ng_template_23_Template(rf, ctx) {}
function BuilderDetailTemplateComponent_ng_template_35_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "cap-button", 6);
    i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_ng_template_35_div_0_Template_cap_button_click_1_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r11.closeSidebar());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "cap-button", 27);
    i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_ng_template_35_div_0_Template_cap_button_click_3_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r12);
      const config_r10 = restoredCtx.ngIf;
      const ctx_r13 = i0.ɵɵnextContext(2);
      const _r4 = i0.ɵɵreference(33);
      return i0.ɵɵresetView(ctx_r13.saveConfig(config_r10, _r4.form.value));
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 2, "button.cancel"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(4, 4, "button.submit"));
  }
}
function BuilderDetailTemplateComponent_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BuilderDetailTemplateComponent_ng_template_35_div_0_Template, 5, 6, "div", 25);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r5.formConfiguration$));
  }
}
const _c4 = function () {
  return {
    width: "470px"
  };
};
let BuilderUiApiService = /*#__PURE__*/(() => {
  class BuilderUiApiService extends ApiService {
    constructor(apiHttp, builderApiService) {
      super(apiHttp);
      this.builderApiService = builderApiService;
      this.endpoint = 'builder/ui/render/config';
    }
    getFormBuilderConfiguration(key) {
      return this.apiHttp.get(`/${this.endpoint}/${key}`).pipe(responseData);
    }
    getConfigPreview(id, type) {
      return this.builderApiService.get('config-preview', `/builder/ui/render/preview/${id}`).pipe(switchMap(configuration => {
        if (configuration?.data) {
          const splitEndpoint = configuration.data.source.endpoint.split('/');
          const sourceEndpointKey = splitEndpoint[splitEndpoint.length - (type === 'list' ? 1 : 2)];
          const typeKey = `${type}_${sourceEndpointKey}`;
          configuration.data.source.endpoint = configuration.data.source.endpoint.replace(sourceEndpointKey, typeKey);
          if (configuration.data.filters?.fields.length) {
            configuration.data.filters.fields.map(field => {
              field.options.action.endpoint = field.options.action.endpoint.replace(sourceEndpointKey, typeKey);
              return field;
            });
          }
          if (configuration.data?.groups) {
            configuration.data.groups = configuration.data?.groups.map(group => {
              group.inputs = group.inputs.map(input => {
                if (input.options?.action?.endpoint) {
                  input.options.action.endpoint = input.options.action.endpoint.replace(sourceEndpointKey, typeKey);
                }
                return input;
              });
              return group;
            });
          }
          if (configuration.data.submit) {
            configuration.data.submit.endpoint = configuration.data.submit.endpoint.replace(sourceEndpointKey, typeKey);
          }
          return of(configuration);
        }
        return null;
      }), responseData);
    }
    getProjectDatabaseConfigurationList() {
      return this.apiHttp.get('/builder/config');
    }
    static {
      this.ɵfac = function BuilderUiApiService_Factory(t) {
        return new (t || BuilderUiApiService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2.BuilderApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderUiApiService,
        factory: BuilderUiApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BuilderUiApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderUiConfigService = /*#__PURE__*/(() => {
  class BuilderUiConfigService {
    constructor() {
      this.config = new BehaviorSubject(null);
    }
    getConfig() {
      return this.config.asObservable();
    }
    getConfigSnapshot() {
      return this.config.getValue();
    }
    patchConfig(config) {
      this.config.next({
        ...this.config.getValue(),
        ...config
      });
    }
    setConfig(config) {
      this.config.next(config);
    }
    resetConfig() {
      this.config.next(null);
    }
    static {
      this.ɵfac = function BuilderUiConfigService_Factory(t) {
        return new (t || BuilderUiConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderUiConfigService,
        factory: BuilderUiConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BuilderUiConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderCardComponent = /*#__PURE__*/(() => {
  class BuilderCardComponent {
    constructor() {
      this.isCollapsed = true;
    }
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
    static {
      this.ɵfac = function BuilderCardComponent_Factory(t) {
        return new (t || BuilderCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BuilderCardComponent,
        selectors: [["cpb-builder-card"]],
        inputs: {
          title: "title",
          collapsable: "collapsable",
          isCollapsed: "isCollapsed"
        },
        ngContentSelectors: _c1,
        decls: 7,
        vars: 3,
        consts: [[1, "builder-card"], [1, "builder-card__title"], [4, "ngIf", "ngIfElse"], [1, "builder-card__body", 3, "hidden"], ["defaultTitle", ""], [3, "click"], [1, "fas", "collapse-toggle", 3, "ngClass", "click"]],
        template: function BuilderCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, BuilderCardComponent_ng_container_2_Template, 4, 5, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, BuilderCardComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const _r1 = i0.ɵɵreference(6);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.collapsable)("ngIfElse", _r1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.collapsable && ctx.isCollapsed);
          }
        },
        dependencies: [i10.NgClass, i10.NgIf],
        styles: [".builder-card{background:#fff;padding:20px;border-radius:10px;box-shadow:0 1px 2px #00000026;width:100%;margin-bottom:1rem}.builder-card .builder-card__title{display:flex;justify-content:space-between;color:#333;font-weight:600;border-bottom:1px solid #ddd;padding-bottom:10px}.builder-card .builder-card__title span,.builder-card .builder-card__title .collapse-toggle{cursor:pointer}.builder-card__body{padding-top:20px}\n"],
        encapsulation: 2
      });
    }
  }
  return BuilderCardComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderDetailTemplateComponent = /*#__PURE__*/(() => {
  class BuilderDetailTemplateComponent {
    constructor(formBuilderService, formSaverService, changeDetectorRef, store, route, router, formRendererService, configApiService, toastService, translateService, builderUiConfigService, formBuilder, baseUrl) {
      this.formBuilderService = formBuilderService;
      this.formSaverService = formSaverService;
      this.changeDetectorRef = changeDetectorRef;
      this.store = store;
      this.route = route;
      this.router = router;
      this.formRendererService = formRendererService;
      this.configApiService = configApiService;
      this.toastService = toastService;
      this.translateService = translateService;
      this.builderUiConfigService = builderUiConfigService;
      this.formBuilder = formBuilder;
      this.baseUrl = baseUrl;
      this.configChange = new EventEmitter();
      this.onSubmit = new EventEmitter();
      this.type = CapturumBuilderType.form;
      this.hideSetDevelopmentConfig = false;
      this.messages = [];
      this.destroy$ = new Subject();
      this.commentForm = this.formBuilder.group({
        comment: null
      });
    }
    ngOnInit() {
      this.formConfiguration$ = this.formBuilderService.getFormBuilderConfiguration(this.key).pipe(shareReplay(1));
      this.formRendererService.getSourceValueByKey(this.key).pipe(filter(Boolean), take(1)).subscribe(value => {
        if (value.key) {
          this.title = value.key;
        }
        this.commentForm.patchValue({
          comment: value.comment ?? null
        });
        if (value.messages) {
          this.messages = value.messages;
        }
        const config = clone(value);
        this.builderUiConfigService.setConfig(value);
        this.configChange.emit(config);
      });
      this.showConfigSidebar = !this.route.snapshot.paramMap.get('id');
      this.hideSetDevelopmentConfig = !this.route.snapshot.paramMap.get('id');
      this.commentForm.valueChanges.pipe(debounceTime(200), takeUntil(this.destroy$)).subscribe(value => {
        this.builderUiConfigService.patchConfig(value);
      });
    }
    ngOnDestroy() {
      this.formRendererService.setSourceValue(this.key, null);
      this.builderUiConfigService.resetConfig();
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    saveConfig(config, value) {
      const stateConfig = this.builderUiConfigService.getConfigSnapshot();
      this.formRendererService.setIsSubmitted(this.key);
      const submitValue = {
        ...stateConfig,
        ...value,
        filters: {
          ...stateConfig?.filters,
          ...value.filters
        }
      };
      this.formSaverService.submitToBackend(config.submit.endpoint, submitValue, this.key).pipe(take(1)).subscribe(response => {
        if (response?.data) {
          this.showSuccessToast('builders.set-config.toast.message');
          this.builderUiConfigService.setConfig(response.data);
          this.configChange.emit(response.data);
        }
        this.router.navigate([`../${response.data.id}`], {
          relativeTo: this.route
        }).then(() => {
          this.showConfigSidebar = false;
          this.closeSidebar();
        });
        this.changeDetectorRef.detectChanges();
      });
    }
    submit() {
      this.onSubmit.emit();
    }
    cancel() {
      this.router.navigate(['../..'], {
        relativeTo: this.route
      });
    }
    setConfig() {
      this.configApiService.setConfig(this.configId).pipe(take(1)).subscribe(() => {
        this.showSuccessToast('builders.set-config.toast.message');
      });
    }
    openPreview() {
      const url = this.router.serializeUrl(this.router.createUrlTree([`${this.baseUrl}/config-preview/${this.type}/${this.configId}`], {
        relativeTo: this.route
      }));
      window.open(url, '_blank');
    }
    closeSidebar() {
      this.showConfigSidebar = false;
      this.sidebar.closeSidebar();
    }
    showSuccessToast(key) {
      this.toastService.success(this.translateService.instant('toast.success.title'), this.translateService.instant(key));
    }
    static {
      this.ɵfac = function BuilderDetailTemplateComponent_Factory(t) {
        return new (t || BuilderDetailTemplateComponent)(i0.ɵɵdirectiveInject(BuilderUiApiService), i0.ɵɵdirectiveInject(i2$1.FormSaverService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i2$1.FormRendererService), i0.ɵɵdirectiveInject(i2.ConfigApiService), i0.ɵɵdirectiveInject(i6.ToastService), i0.ɵɵdirectiveInject(i7.TranslateService), i0.ɵɵdirectiveInject(BuilderUiConfigService), i0.ɵɵdirectiveInject(i9.FormBuilder), i0.ɵɵdirectiveInject(CAPTURUM_BUILDERS_BASE_URL));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BuilderDetailTemplateComponent,
        selectors: [["cpb-builder-detail-template"]],
        viewQuery: function BuilderDetailTemplateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidebar = _t.first);
          }
        },
        inputs: {
          key: "key",
          title: "title",
          contentRightTemplate: "contentRightTemplate",
          configId: "configId",
          translationKey: "translationKey",
          type: "type"
        },
        outputs: {
          configChange: "configChange",
          onSubmit: "onSubmit"
        },
        ngContentSelectors: _c1,
        decls: 36,
        vars: 36,
        consts: [[1, "builder-detail-template"], [1, "builder-detail-template__messages"], ["class", "builder-message", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "builder-detail-template__header"], [1, "builder-detail-template__header-actions"], ["styleClass", "primary", 3, "label", "click"], ["styleClass", "secondary", 3, "label", "click"], ["styleClass", "secondary", 3, "label", "click", 4, "ngIf"], ["styleClass", "secondary", "icon", "fas fa-eye", 3, "label", "click"], [1, "builder-detail-template__content"], [1, "builder-detail-template__content-center"], [1, "builder-detail-template__content-right"], [1, "general-settings-card"], [3, "title"], [3, "ngTemplateOutlet"], [3, "formGroup"], ["formControlName", "comment"], [3, "visible", "title", "visibleChange"], ["sidebar", ""], [1, "form-container"], [3, "formConfiguration", "formKey", "showHeader", "modelId"], ["form", ""], ["capTemplate", "footer"], [1, "builder-message", 3, "ngClass"], [1, "fas", 3, "ngClass"], ["class", "save-actions", 4, "ngIf"], [1, "save-actions"], ["styleClass", "success", 3, "label", "click"]],
        template: function BuilderDetailTemplateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, BuilderDetailTemplateComponent_div_2_Template, 3, 7, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "h2");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4)(7, "cap-button", 5);
            i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_Template_cap_button_click_7_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "cap-button", 6);
            i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_Template_cap_button_click_9_listener() {
              return ctx.cancel();
            });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, BuilderDetailTemplateComponent_cap_button_11_Template, 2, 3, "cap-button", 7);
            i0.ɵɵelementStart(12, "cap-button", 8);
            i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_Template_cap_button_click_12_listener() {
              return ctx.openPreview();
            });
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(14, "div", 9)(15, "div", 10);
            i0.ɵɵprojection(16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "div", 11)(18, "div", 12)(19, "cpb-builder-card", 13);
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵelementStart(21, "cap-button", 5);
            i0.ɵɵlistener("click", function BuilderDetailTemplateComponent_Template_cap_button_click_21_listener() {
              return ctx.showConfigSidebar = !ctx.showConfigSidebar;
            });
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(23, BuilderDetailTemplateComponent_ng_template_23_Template, 0, 0, "ng-template", 14);
            i0.ɵɵelementStart(24, "cpb-builder-card", 13);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementStart(26, "form", 15);
            i0.ɵɵelement(27, "cap-textarea", 16);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(28, "cap-sidebar", 17, 18);
            i0.ɵɵlistener("visibleChange", function BuilderDetailTemplateComponent_Template_cap_sidebar_visibleChange_28_listener($event) {
              return ctx.showConfigSidebar = $event;
            });
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵelementStart(31, "div", 19);
            i0.ɵɵelement(32, "cpb-form-renderer", 20, 21);
            i0.ɵɵpipe(34, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(35, BuilderDetailTemplateComponent_ng_template_35_Template, 2, 3, "ng-template", 22);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.messages);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(8, 19, "button.submit"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 21, "button.cancel"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.hideSetDevelopmentConfig);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(13, 23, "builders.button.preview"));
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(20, 25, "builders.ui." + ctx.type + "-settings"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(22, 27, "builders.ui.button.show-" + ctx.type + "-settings"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentRightTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(25, 29, "builders.edit_input.comment"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.commentForm);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(35, _c4));
            i0.ɵɵproperty("visible", ctx.showConfigSidebar)("title", i0.ɵɵpipeBind1(30, 31, "builders.ui." + ctx.type + "-settings"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("formConfiguration", i0.ɵɵpipeBind1(34, 33, ctx.formConfiguration$))("formKey", ctx.key)("showHeader", false)("modelId", ctx.configId);
          }
        },
        dependencies: [i10.NgClass, i10.NgForOf, i10.NgIf, i10.NgTemplateOutlet, i9.ɵNgNoValidate, i9.NgControlStatus, i9.NgControlStatusGroup, i9.FormGroupDirective, i9.FormControlName, i11.CapturumButtonComponent, i2$1.CapturumFormRendererComponent, i12.CapturumSidebarComponent, i6.CapturumTemplateDirective, i13.CapturumTextareaComponent, BuilderCardComponent, i10.AsyncPipe, i7.TranslatePipe],
        styles: [".builder-detail-template .builder-detail-template__messages{margin-bottom:15px}.builder-detail-template .builder-detail-template__messages .builder-message{border-radius:5px;padding:15px;margin-bottom:15px}.builder-detail-template .builder-detail-template__messages .builder-message.success{background-color:#68e76f80;border:1px solid #68e76f}.builder-detail-template .builder-detail-template__messages .builder-message.warning{background-color:#faa20080;border:1px solid #faa200}.builder-detail-template .builder-detail-template__messages .builder-message.info{background-color:#e9e9ff;border:1px solid #696cff}.builder-detail-template__header,.save-actions{display:flex;justify-content:space-between}.builder-detail-template__content{display:flex}@media screen and (max-width: 1130px){.builder-detail-template__content{flex-wrap:wrap}}.builder-detail-template__content .builder-detail-template__content-right{flex-grow:1;flex-basis:0;padding:.5rem .5rem .5rem 30px}@media screen and (max-width: 1130px){.builder-detail-template__content .builder-detail-template__content-right{padding-left:.5rem;order:1}}.builder-detail-template__content-center{flex:0 0 auto;width:70%;border-right:1px dashed #ddd;padding:.5rem 30px .5rem .5rem}@media screen and (max-width: 1130px){.builder-detail-template__content-center{width:100%;border-right:none;padding-right:.5rem;order:2}}.builder-detail-template__header-actions>cap-button{margin-right:15px}.form-container{padding:15px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BuilderDetailTemplateComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderUiModule = /*#__PURE__*/(() => {
  class CapturumBuilderUiModule {
    static {
      this.ɵfac = function CapturumBuilderUiModule_Factory(t) {
        return new (t || CapturumBuilderUiModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumBuilderUiModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, CapturumInputModule, CapturumButtonModule, CapturumFormRendererModule, CapturumSidebarModule, CapturumSharedModule, CapturumFormRendererModule, CapturumListRendererModule, TranslateModule, CapturumBuilderCoreModule, CapturumDropdownModule, CapturumTextareaModule, CapturumInputSwitchModule, CapturumInfoTableModule]
      });
    }
  }
  return CapturumBuilderUiModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of builders/form-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BuilderCardComponent, BuilderDetailTemplateComponent, BuilderUiApiService, BuilderUiConfigService, CapturumBuilderUiModule };
